import { useEffect, useState } from "react";
import { appAssets } from "../../config/assets";
import { homeSliderItems } from "../../config/homeSlider";

type SlideItem = {
    id: number;
    title: string;
    description: string;
    image: string;
};

const slides: SlideItem[] = [
    {
        id: 1,
        title: homeSliderItems[0].title,
        description:
            homeSliderItems[0].description,
        image: appAssets.homeSlider.slide1,
    },
    {
        id: 2,
        title: homeSliderItems[1].title,
        description:
            homeSliderItems[1].description,
        image: appAssets.homeSlider.slide2,
    },
    {
        id: 3,
        title: homeSliderItems[3].title,
        description:
            homeSliderItems[3].description,
        image: appAssets.homeSlider.slide3,
    },
    {
        id: 4,
        title: homeSliderItems[3].title,
        description:
            homeSliderItems[3].description,
        image: appAssets.homeSlider.slide4,
    }
];

export default function HomeHeroSlider() {
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const interval = window.setInterval(() => {
            setCurrentIndex((prev) => (prev + 1) % slides.length);
        }, 5000);

        return () => window.clearInterval(interval);
    }, []);

    const goToSlide = (index: number) => {
        setCurrentIndex(index);
    };

    const goToPrevious = () => {
        setCurrentIndex((prev) => (prev - 1 + slides.length) % slides.length);
    };

    const goToNext = () => {
        setCurrentIndex((prev) => (prev + 1) % slides.length);
    };

    return (
        <section className="w-full bg-[#071120] py-6 md:py-8">
            <div className="mx-auto max-w-[1400px] px-4 md:px-6 lg:px-8">
                <div className="relative overflow-hidden rounded-3xl border border-white/10 bg-[#0b1220] shadow-[0_20px_60px_rgba(0,0,0,0.35)]">
                    <div className="relative aspect-[16/6] min-h-[260px] w-full md:min-h-[360px]">
                        {slides.map((slide, index) => (
                            <div
                                key={slide.id}
                                className={`absolute inset-0 transition-opacity duration-700 ${
                                    index === currentIndex ? "opacity-100" : "opacity-0"
                                }`}
                            >
                                <img
                                    src={slide.image}
                                    alt={slide.title}
                                    className="h-full w-full object-cover"
                                />

                                <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/35 to-black/20" />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />

                                <div className="absolute left-0 top-0 flex h-full w-full items-end">
                                    <div className="max-w-3xl px-6 pb-8 pt-6 md:px-10 md:pb-12">
                    <span className="mb-3 inline-flex rounded-full border border-[#e5ff00]/30 bg-[#e5ff00]/10 px-3 py-1 text-xs font-black uppercase tracking-[0.2em] text-[#e5ff00]">
                      Ligue des 2 Zéros
                    </span>

                                        <h2 className="max-w-2xl text-2xl font-black uppercase leading-tight text-white md:text-4xl lg:text-5xl">
                                            {slide.title}
                                        </h2>

                                        <p className="mt-3 max-w-2xl text-sm leading-6 text-white/80 md:mt-4 md:text-base">
                                            {slide.description}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}

                        <button
                            type="button"
                            onClick={goToPrevious}
                            className="absolute left-4 top-1/2 z-10 flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full border border-white/15 bg-black/35 text-xl font-bold text-white backdrop-blur-sm transition hover:bg-black/55"
                            aria-label="Slide précédente"
                        >
                            ‹
                        </button>

                        <button
                            type="button"
                            onClick={goToNext}
                            className="absolute right-4 top-1/2 z-10 flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full border border-white/15 bg-black/35 text-xl font-bold text-white backdrop-blur-sm transition hover:bg-black/55"
                            aria-label="Slide suivante"
                        >
                            ›
                        </button>

                        <div className="absolute bottom-4 left-1/2 z-10 flex -translate-x-1/2 items-center gap-2">
                            {slides.map((slide, index) => (
                                <button
                                    key={slide.id}
                                    type="button"
                                    onClick={() => goToSlide(index)}
                                    className={`h-2.5 rounded-full transition-all ${
                                        index === currentIndex
                                            ? "w-8 bg-[#e5ff00]"
                                            : "w-2.5 bg-white/45 hover:bg-white/70"
                                    }`}
                                    aria-label={`Aller au slide ${index + 1}`}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}